// TODO temporarily disable eslint on this file until v1.0 Unwired is complete/services are used
/* eslint @typescript-eslint/no-unused-vars: "off" */
/* eslint @typescript-eslint/no-explicit-any: "off" */
/* eslint @typescript-eslint/no-non-null-assertion: "off" */
// WorkflowService

import { axios, dateOnlyTransformer, dateTransformer } from "../axios";
import { BaseResponse, BaseResponseWithSingle, Status } from "../Shared";
import {
  AddOrRemoveWorkflowStepRequest,
  AddOrRemoveWorkflowStepResponse,
  AddOrRemoveWorkflowTemplateStepRequest,
  AddOrRemoveWorkflowTemplateStepResponse,
  ApplyWorkflowTemplateRequest,
  ApplyWorkflowTemplateResponse,
  CreateWorkflowTaskRequest,
  CreateWorkflowTaskResponse,
  CreateWorkflowTemplateRequest,
  CreateWorkflowTemplateResponse,
  CreateWorkflowTemplateTaskRequest,
  CreateWorkflowTemplateTaskResponse,
  DeleteWorkflowRequest,
  DeleteWorkflowTaskRequest,
  DeleteWorkflowTemplateTaskRequest,
  ReorderWorkflowTemplateStepsRequest,
  UpdateWorkflowOrganisationRequest,
  UpdateWorkflowStepRequest,
  UpdateWorkflowStepResponse,
  UpdateWorkflowTaskRequest,
  UpdateWorkflowTaskResponse,
  UpdateWorkflowTemplateRequest,
  UpdateWorkflowTemplateResponse,
  UpdateWorkflowTemplateStepRequest,
  UpdateWorkflowTemplateStepResponse,
  UpdateWorkflowTemplateTaskRequest,
  UpdateWorkflowTemplateTaskResponse,
} from "./Types";

export const createWorkflowTemplate = async (
  req: CreateWorkflowTemplateRequest
): Promise<BaseResponseWithSingle<CreateWorkflowTemplateResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateWorkflowTemplateResponse>>({
      method: "post",
      url: "workflow/template",
      data: { ...req, validTo: dateTransformer(req.validTo) },
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowTemplate = async (
  req: UpdateWorkflowTemplateRequest
): Promise<BaseResponseWithSingle<UpdateWorkflowTemplateResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateWorkflowTemplateResponse>>({
      method: "patch",
      url: "workflow/template",
      data: { ...req, validTo: dateTransformer(req.validTo) },
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteWorkflowTemplateTask = async (req: DeleteWorkflowTemplateTaskRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "delete",
      url: "workflow/template/task",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const addOrRemoveWorkflowTemplateStep = async (
  req: AddOrRemoveWorkflowTemplateStepRequest
): Promise<BaseResponseWithSingle<AddOrRemoveWorkflowTemplateStepResponse>> => {
  return axios
    .request<BaseResponseWithSingle<AddOrRemoveWorkflowTemplateStepResponse>>({
      method: "post",
      url: "workflow/template/step",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const reorderWorkflowTemplateStep = async (req: ReorderWorkflowTemplateStepsRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "patch",
      url: "workflow/template/steps/reorder",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowTemplateStep = async (
  req: UpdateWorkflowTemplateStepRequest
): Promise<BaseResponseWithSingle<UpdateWorkflowTemplateStepResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateWorkflowTemplateStepResponse>>({
      method: "patch",
      url: "workflow/template/step",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const createWorkflowTemplateTask = async (
  req: CreateWorkflowTemplateTaskRequest
): Promise<BaseResponseWithSingle<CreateWorkflowTemplateTaskResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateWorkflowTemplateTaskResponse>>({
      method: "post",
      url: "workflow/template/task",
      data: { ...req },
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowTemplateTask = async (
  req: UpdateWorkflowTemplateTaskRequest
): Promise<BaseResponseWithSingle<UpdateWorkflowTemplateTaskResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateWorkflowTemplateTaskResponse>>({
      method: "patch",
      url: "workflow/template/task",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const addOrRemoveWorkflowStep = (
  req: AddOrRemoveWorkflowStepRequest
): Promise<BaseResponseWithSingle<AddOrRemoveWorkflowStepResponse>> => {
  return axios
    .request<BaseResponseWithSingle<AddOrRemoveWorkflowStepResponse>>({
      method: "post",
      url: "workflow/step",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowStep = async (
  req: UpdateWorkflowStepRequest
): Promise<BaseResponseWithSingle<UpdateWorkflowStepResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateWorkflowStepResponse>>({
      method: "patch",
      url: "workflow/step",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const applyWorkflowTemplate = async (
  req: ApplyWorkflowTemplateRequest
): Promise<BaseResponseWithSingle<ApplyWorkflowTemplateResponse>> => {
  return axios
    .request<BaseResponseWithSingle<ApplyWorkflowTemplateResponse>>({
      method: "post",
      url: "workflow/template/apply",
      data: req,
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteWorkflow = async (req: DeleteWorkflowRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "delete",
      url: "workflow",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const createWorkflowTask = async (
  req: CreateWorkflowTaskRequest
): Promise<BaseResponseWithSingle<CreateWorkflowTaskResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateWorkflowTaskResponse>>({
      method: "post",
      url: "workflow/task",
      data: { ...req, deadlineDate: dateOnlyTransformer(req.deadlineDate) },
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowTask = async (
  req: UpdateWorkflowTaskRequest
): Promise<BaseResponseWithSingle<UpdateWorkflowTaskResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateWorkflowTaskResponse>>({
      method: "patch",
      url: "workflow/task",
      data: { ...req, deadlineDate: dateOnlyTransformer(req.deadlineDate) },
    })
    .then((res) => {
      return {
        status: Status.Success,
        data: res.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteWorkflowTask = async (req: DeleteWorkflowTaskRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "delete",
      url: "workflow/task",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateWorkflowOrganisation = async (req: UpdateWorkflowOrganisationRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "post",
      url: "workflow/organisation",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};
